import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Identifying the Voice (Without Identifying With It)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I stop calling it “me.” It is a voice — and it is cruel."
    ],
      [
      "Daily intention: Today I stop calling it “me.” It is a voice — and it is cruel."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One slow breath.",
      "In my heart: “This is an inner voice — not absolute truth.”"
    ],
      [
      "I pause with myself.",
      "One slow breath.",
      "In my heart: “This is an inner voice — not absolute truth.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What cruel sentence came up for me today?\n[Write here]",
      "2. In what tone is it said? (angry / dismissive / humiliating)\n[Write here]",
      "3. When is this voice strongest?\n[Write here]"
    ],
      [
      "1. What cruel sentence came up for me today?\n[Write here]",
      "2. In what tone is it said? (angry / dismissive / humiliating)\n[Write here]",
      "3. When is this voice strongest?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Recognizing the voice is already the first step to freedom."
    ],
      [
      "Closing",
      "Recognizing the voice is already the first step to freedom."
    ]
    ),
    action: localizedGenderNode(
      "Once today: “This is the critical voice. Not me.”",
      "Once today: “This is the critical voice. Not me.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "What the Voice Is Trying to Do for Me",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I check: even cruel criticism tries to protect."
    ],
      [
      "Daily intention: Today I check: even cruel criticism tries to protect."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What does the voice say will happen if I’m not hard on myself?\n[Write here]",
      "2. What is it trying to protect me from? (failure / rejection / shame)\n[Write here]",
      "3. What less violent way could protect me?\n[Write here]"
    ],
      [
      "1. What does the voice say will happen if I’m not hard on myself?\n[Write here]",
      "2. What is it trying to protect me from? (failure / rejection / shame)\n[Write here]",
      "3. What less violent way could protect me?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "The intention may be protection — the method is harmful."
    ],
      [
      "Closing",
      "The intention may be protection — the method is harmful."
    ]
    ),
    action: localizedGenderNode(
      "I say: “I understand the fear. Not the violence.”",
      "I say: “I understand the fear. Not the violence.”"
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Responsibility vs. Self-Punishment",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I separate learning from destroying myself."
    ],
      [
      "Daily intention: Today I separate learning from destroying myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What do I keep blaming myself for?\n[Write here]",
      "2. What small part is actually my responsibility — and what isn’t?\n[Write here]",
      "3. What does responsibility sound like without humiliation?\n[Write here]"
    ],
      [
      "1. What do I keep blaming myself for?\n[Write here]",
      "2. What small part is actually my responsibility — and what isn’t?\n[Write here]",
      "3. What does responsibility sound like without humiliation?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Responsibility builds. Punishment destroys."
    ],
      [
      "Closing",
      "Responsibility builds. Punishment destroys."
    ]
    ),
    action: localizedGenderNode(
      "When blame arises — I rephrase without insult.",
      "When blame arises — I rephrase without insult."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Comparison as Hidden Self-Criticism",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I see how comparison becomes judgment."
    ],
      [
      "Daily intention: Today I see how comparison becomes judgment."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Who do I compare myself to when I judge myself?\n[Write here]",
      "2. What is always missing for me in that comparison?\n[Write here]",
      "3. What truth about me doesn’t fit this comparison?\n[Write here]"
    ],
      [
      "1. Who do I compare myself to when I judge myself?\n[Write here]",
      "2. What is always missing for me in that comparison?\n[Write here]",
      "3. What truth about me doesn’t fit this comparison?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Comparison doesn’t reflect truth — it sharpens pain."
    ],
      [
      "Closing",
      "Comparison doesn’t reflect truth — it sharpens pain."
    ]
    ),
    action: localizedGenderNode(
      "Once today: “I step out of comparison.”",
      "Once today: “I step out of comparison.”"
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "The Shame Beneath the Criticism",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I touch the shame — without running away."
    ],
      [
      "Daily intention: Today I touch the shame — without running away."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What am I ashamed of in myself?\n[Write here]",
      "2. What am I afraid others will see?\n[Write here]",
      "3. What humanity exists in this place?\n[Write here]"
    ],
      [
      "1. What am I ashamed of in myself?\n[Write here]",
      "2. What am I afraid others will see?\n[Write here]",
      "3. What humanity exists in this place?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Shame signals a wound — not a defect."
    ],
      [
      "Closing",
      "Shame signals a wound — not a defect."
    ]
    ),
    action: localizedGenderNode(
      "One sentence of humanity toward myself.",
      "One sentence of humanity toward myself."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "How I Talk to Myself When I Make a Mistake",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I notice my language in moments of error."
    ],
      [
      "Daily intention: Today I notice my language in moments of error."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What do I say to myself when I make a mistake?\n[Write here]",
      "2. How does it affect my body?\n[Write here]",
      "3. How would I speak to a child in the same situation?\n[Write here]"
    ],
      [
      "1. What do I say to myself when I make a mistake?\n[Write here]",
      "2. How does it affect my body?\n[Write here]",
      "3. How would I speak to a child in the same situation?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Mistakes do not require violence."
    ],
      [
      "Closing",
      "Mistakes do not require violence."
    ]
    ),
    action: localizedGenderNode(
      "I choose one repairing sentence instead of humiliation.",
      "I choose one repairing sentence instead of humiliation."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Experiment: A Day With Less Judgment",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I experiment with reducing judgment — not eliminating it."
    ],
      [
      "Daily intention: Today I experiment with reducing judgment — not eliminating it."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. In which moments does judgment jump in fastest?\n[Write here]",
      "2. What softer wording could replace it?\n[Write here]",
      "3. What do I want to test today?\n[Write here]"
    ],
      [
      "1. In which moments does judgment jump in fastest?\n[Write here]",
      "2. What softer wording could replace it?\n[Write here]",
      "3. What do I want to test today?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "This is an experiment, not a test."
    ],
      [
      "Closing",
      "This is an experiment, not a test."
    ]
    ),
    action: localizedGenderNode(
      "Once today — soft wording instead of cruelty.",
      "Once today — soft wording instead of cruelty."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Allowing Imperfection (ACT)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I allow myself to be imperfect — for one minute."
    ],
      [
      "Daily intention: Today I allow myself to be imperfect — for one minute."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Which imperfection triggers my criticism most?\n[Write here]",
      "2. One minute: I let it be here.\nWhat happened?\n[Write here]",
      "3. What did I learn about the feeling?\n[Write here]"
    ],
      [
      "1. Which imperfection triggers my criticism most?\n[Write here]",
      "2. One minute: I let it be here.\nWhat happened?\n[Write here]",
      "3. What did I learn about the feeling?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Imperfection does not destroy me."
    ],
      [
      "Closing",
      "Imperfection does not destroy me."
    ]
    ),
    action: localizedGenderNode(
      "One minute only. That is enough.",
      "One minute only. That is enough."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Who I Am Without This Voice",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I remember who I am beneath the criticism."
    ],
      [
      "Daily intention: Today I remember who I am beneath the criticism."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Who was I before this voice became dominant?\n[Write here]",
      "2. Which part of me faded over time?\n[Write here]",
      "3. What do I miss about myself?\n[Write here]"
    ],
      [
      "1. Who was I before this voice became dominant?\n[Write here]",
      "2. Which part of me faded over time?\n[Write here]",
      "3. What do I miss about myself?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "I am not the voice. I am the person beneath it."
    ],
      [
      "Closing",
      "I am not the voice. I am the person beneath it."
    ]
    ),
    action: localizedGenderNode(
      "One action that reconnects me to my true self.",
      "One action that reconnects me to my true self."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Compassion Without Giving Up Growth",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I understand that compassion does not cancel growth."
    ],
      [
      "Daily intention: Today I understand that compassion does not cancel growth."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What do I fear if I’m gentle with myself?\n[Write here]",
      "2. What growth is possible with compassion?\n[Write here]",
      "3. What one gentle sentence may I adopt?\n[Write here]"
    ],
      [
      "1. What do I fear if I’m gentle with myself?\n[Write here]",
      "2. What growth is possible with compassion?\n[Write here]",
      "3. What one gentle sentence may I adopt?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Compassion is fertile ground for growth."
    ],
      [
      "Closing",
      "Compassion is fertile ground for growth."
    ]
    ),
    action: localizedGenderNode(
      "Hand on body + the gentle sentence.",
      "Hand on body + the gentle sentence."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Setting a Boundary With the Critical Voice",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I place an inner boundary."
    ],
      [
      "Daily intention: Today I place an inner boundary."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Which sentence from the voice am I no longer willing to hear?\n[Write here]",
      "2. What does an inner boundary sound like?\n[Write here]",
      "3. What do I fear if I set this boundary?\n[Write here]"
    ],
      [
      "1. Which sentence from the voice am I no longer willing to hear?\n[Write here]",
      "2. What does an inner boundary sound like?\n[Write here]",
      "3. What do I fear if I set this boundary?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Even inner voices have limits."
    ],
      [
      "Closing",
      "Even inner voices have limits."
    ]
    ),
    action: localizedGenderNode(
      "I stop one sentence mid-way.",
      "I stop one sentence mid-way."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Changing the Tone, Not Erasing the Story",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I change tone — not erase the past."
    ],
      [
      "Daily intention: Today I change tone — not erase the past."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What story do I tell myself?\n[Write here]",
      "2. How does the same story sound in a humane tone?\n[Write here]",
      "3. Which tone do I choose this week?\n[Write here]"
    ],
      [
      "1. What story do I tell myself?\n[Write here]",
      "2. How does the same story sound in a humane tone?\n[Write here]",
      "3. Which tone do I choose this week?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Tone shapes experience."
    ],
      [
      "Closing",
      "Tone shapes experience."
    ]
    ),
    action: localizedGenderNode(
      "Once today — tone change only.",
      "Once today — tone change only."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Choosing a New Leading Voice",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I choose which voice leads me."
    ],
      [
      "Daily intention: Today I choose which voice leads me."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Which value do I want my voice to express? (respect / truth / softness)\n[Write here]",
      "2. What does that voice sound like?\n[Write here]",
      "3. What do I promise myself on hard days?\n[Write here]"
    ],
      [
      "1. Which value do I want my voice to express? (respect / truth / softness)\n[Write here]",
      "2. What does that voice sound like?\n[Write here]",
      "3. What do I promise myself on hard days?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "I don’t silence a voice — I change leadership."
    ],
      [
      "Closing",
      "I don’t silence a voice — I change leadership."
    ]
    ),
    action: localizedGenderNode(
      "I write a leadership sentence and keep it.",
      "I write a leadership sentence and keep it."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Gentle Closure",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I finish a journey — not a war."
    ],
      [
      "Daily intention: Today I finish a journey — not a war."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What has changed in my relationship with criticism?\n[Write here]",
      "2. What do I understand about myself now?\n[Write here]",
      "3. Return sentence for difficult days:\n[Write here]"
    ],
      [
      "1. What has changed in my relationship with criticism?\n[Write here]",
      "2. What do I understand about myself now?\n[Write here]",
      "3. Return sentence for difficult days:\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Final closure",
      "I am still learning.",
      "But I am no longer against myself.",
      "And that is a deep shift."
    ],
      [
      "Final closure",
      "I am still learning.",
      "But I am no longer against myself.",
      "And that is a deep shift."
    ]
    ),
    action: localizedGenderNode(
      "One action that symbolizes choosing myself.",
      "One action that symbolizes choosing myself."
    ),
  },
].map(buildNormalizedDay);

export const harshSelfCriticismBlueprintEn = buildNormalizedPilotBlueprint({
  id: "harsh_self_criticism_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "harsh_self_criticism",
  category: "general",
  journeyName: {
    he: "שיפוט עצמי אכזרי / ביקורת עצמית אכזרית",
    en: "Harsh Self-Judgment / Cruel Self-Criticism",
    es: "Juicio Interno Cruel / Crítica Interior Severa",
  },
  days,
});

export default harshSelfCriticismBlueprintEn;
